import React, { Component } from 'react';
import { connect } from 'shalala';
import { Dropdown, Button } from 'react-bootstrap';

import { useStore } from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';

class ClientesTypeFilter extends Component {
  state = {};
  timerId = null;

  handleOnSelectFilter = (name, filter) => {
    this.setState({
      [name]: filter !== '' ? filter : '',
    });

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.timerId = setTimeout(() => {
      this.submit();
    }, 5000);
  };

  submit = () => {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...this.state,
    });
  };

  getStatusLegend = () => {
    const { status } = this.state;
    let legend = '';

    switch (status) {
      case '1':
        legend = 'Activo';
        break;

      case '-1':
        legend = 'Suspendido';
        break;

      case '-2':
        legend = 'Falta de pago';
        break;

      default:
        break;
    }

    return legend;
  };

  render() {
    return (
      <div className="mb-1 float-left">
        <Dropdown
          onSelect={this.handleOnSelectFilter.bind(this, 'status')}
          className="float-left mr-1 pb-2"
        >
          <Dropdown.Toggle as={CustomDropdownToggle}>{this.getStatusLegend() || 'Status'}</Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Todos</Dropdown.Item>
            <Dropdown.Item eventKey="1">Activo</Dropdown.Item>
            <Dropdown.Item eventKey="-1">Suspendido</Dropdown.Item>
            <Dropdown.Item eventKey="-2">Falta de pago</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button
          variant="secondary"
          className="text-muted float-xs-right float-sm-right float-md-left"
          onClick={this.submit}
        >
          Aplicar
        </Button>
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.admin.clientes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.clientes.list };
};

export default connect(useStore, mapState, mapActions)(ClientesTypeFilter);
